module.exports = __webpack_public_path__ + "img/Frame4420.223f5da3.png";